import { render, staticRenderFns } from "./speaker-banner-row.vue?vue&type=template&id=be591a60&scoped=true&"
import script from "./speaker-banner-row.vue?vue&type=script&lang=js&"
export * from "./speaker-banner-row.vue?vue&type=script&lang=js&"
import style0 from "./speaker-banner-row.vue?vue&type=style&index=0&id=be591a60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be591a60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be591a60')) {
      api.createRecord('be591a60', component.options)
    } else {
      api.reload('be591a60', component.options)
    }
    module.hot.accept("./speaker-banner-row.vue?vue&type=template&id=be591a60&scoped=true&", function () {
      api.rerender('be591a60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/pageParts/speaker-banner-row.vue"
export default component.exports